import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Navigation, Thumbs } from "swiper";

import Header from '../components/header/Header'
import Footer from '../components/footer/Footer'

import img1 from '../assets/images/sami/sami.png'
import img2 from '../assets/images/sami/sami1.png'
import img3 from '../assets/images/sami/sami2.png'
import img4 from '../assets/images/sami/sami3.png'
import Servicios from '../components/layouts/Servicios';
import dataMontono from '../assets/fake-data/data-montono';
import Action from '../components/layouts/Action';
import heroSami from "../assets/images/sami/sami.png";


const Sami = () => {

    const [thumbsSwiper, setThumbsSwiper] = useState(null);

    const [data] = useState([
        {
            img: img1
        },
        {
            img: img2
        },
        {
            img: img3
        },
        {
            img: img4
        },
    ])
    return (
        <div className='collections'>
            <Header />qa

            <section className="tf-section collection">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="block-text text-black center">
                                <h1 className="heading-bg" data-aos="fade-in" data-aos-duration="1000"><span>Sami</span></h1>
                                <h5 className="sub-title mb-10" data-aos="fade-up" data-aos-duration="1000">Compartida Femenina</h5>
                                <h3 className="title mb-28" data-aos="fade-up" data-aos-duration="1000">Conocé mas de  <br />nuestra habitacion </h3>
                            </div>



                            <div className="banner" data-aos="fade-up" data-aos-duration="1000">
                                <img src={heroSami} alt="Habitación Killa" className="banner-img" />
                            </div>



                        </div>
                    </div>
                    <div className="row" style={{ marginTop: '150px' }}>

                        <div className="col-12">
                            <div className="col-12 mt-5" style={{ marginBottom: '60px' }}>
                                <div className="block-text text-black">
                                    <h3 className="fs-44 mb-31">Habitacion compartida femenina</h3>
                                    <p className="fs-18 ">Esta habitación es compartida y cuenta con 6 camas en literas, esta ubicada en el segundo piso, con acceso rapido a la terraza. A demas contamos con un baño y vestuario exclusivo para mujeres en el primer piso. </p>
                                    <div className="row">
                                        <div className="col-12 col-md-6">
                                            <h3 className="fs-30 mt-37">Servicios</h3>
                                            <ul className="nft s2">

                                                <li><Link to="#"><i className="fa fa-arrow-right"></i><span>Lockers</span></Link></li>
                                                <li><Link to="#"><i className="fa fa-arrow-right"></i><span>Ventiladores</span></Link></li>
                                                <li><Link to="#"><i className="fa fa-arrow-right"></i><span>WiFi</span></Link></li>
                                                <li><Link to="#"><i className="fa fa-arrow-right"></i><span>Baño compartido</span></Link></li>
                                            </ul>
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <h3 className="fs-30 mt-37">Links</h3>
                                            <ul className="nft s2">
                                                <li><Link to="#"><i className="fas fa-external-link-alt"></i><span>Reservar por Whatsapp</span></Link></li>
                                                <li><Link to="#"><i className="fas fa-external-link-alt"></i><span>Reservar por Booking</span></Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="group-image">

                                <Swiper
                                    style={{
                                        "--swiper-navigation-color": "#fff",
                                        "--swiper-pagination-color": "#fff",
                                    }}
                                    spaceBetween={20}
                                    navigation={true}
                                    thumbs={{ swiper: thumbsSwiper }}
                                    modules={[FreeMode, Navigation, Thumbs]}
                                    className="gallery-top"
                                >

                                    {
                                        data.map((data, index) => (
                                            <SwiperSlide key={index}>
                                                <div style={{ textAlign: 'center', borderRadius: '50px', overflow: 'hidden', width: '100%' }}>
                                                    <img src={data.img} alt="Monteno" style={{ width: '100%', height: '85vh', objectFit: 'cover', borderRadius: '50px', margin: '0 auto', display: 'block' }} />
                                                </div>
                                            </SwiperSlide>
                                        ))
                                    }
                                </Swiper>
                                <Swiper
                                    onSwiper={setThumbsSwiper}
                                    spaceBetween={20}
                                    slidesPerView={4}
                                    freeMode={true}
                                    watchSlidesProgress={true}
                                    modules={[FreeMode, Navigation, Thumbs]}
                                    className="gallery-thumbs"
                                >
                                    {
                                        data.map((data, index) => (
                                            <SwiperSlide key={index}>
                                                <div style={{ width: '100%' }}>
                                                    <img src={data.img} alt="Monteno" style={{ width: '100%', height: '150px', objectFit: 'cover', borderRadius: '15px' }} />
                                                </div>
                                            </SwiperSlide>
                                        ))
                                    }
                                </Swiper>

                            </div>
                        </div>

                    </div>
                </div>

            </section>

            <Servicios data={dataMontono} />
            <Action />
            <Footer />
        </div>
    );
}
export default Sami;